import { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useContext, useRef } from "react";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Input, Card, Tooltip, Textarea, } from "@fluentui/react-components";
import { BookTemplate20Regular, Filter20Filled, FilterDismiss20Filled, CheckmarkRegular, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, AddSquare20Regular, Info20Filled, Delete20Regular, PanelLeftKey20Regular, HomePerson20Regular, LayerDiagonalPerson20Regular, PersonCircle20Regular, Settings20Regular, ArrowUpload20Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { primaryIcon, secondaryIcon, overflowDivider, buttonContent, lightTheme, messageTheme, SubSectionResponsive, dashboardTheme } from "../../styles/customStyles";
import { ToastComponent } from "../../components/toast/toast.component";
import { Admin_func } from "../../api/administration/admin_func";
import { Form } from "@rjsf/fluent-ui";
import { GlobalContext } from "../../hooks/globalContext";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { convertToExcelFormat, convertToLocalTimezone, convertUTCToReadableFormat } from "../../utility/utils";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import validator from '@rjsf/validator-ajv8';
import DialogBox from "../../components/dialog/dialog.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import apiCall from "../../utility/api";
import ManageView from "../../components/manage_view/manageView.component";
import { AdministrationPages } from "../../components/side_menu/InlineSidenav";


export const VersionUpdate = () => {

    const navigate = useNavigate();
    const contextValue: any = useContext(GlobalContext);
    const formRef = useRef(null);
    const handle = useFullScreenHandle();
    var tenantName = contextValue.tenantName;
    var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
    const [formDataAdmin, setFormDataAdmin]: any = useState({});
    const [formDataRole, setFormDataRole]: any = useState({});
    const [final_data, set_final_data]: any = useState(null);
    const [saveRoleDetails, setSaveRoleDetails]: any = useState(false)
    const [saveBtnClicked, setSaveBtnClicked]: any = useState(false);
    const [tableData, setTableData] = useState([]);
    const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
    const [overlayOpen, setOverlayOpen] = useState(false);
    const [searchVal, setSearchVal] = useState("");
    const [totalPages, setTotalPages] = useState(1);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [exportData, setExportData] = useState([]);
    const [filterMenuOpen, setFilterMenuOpen] = useState(false);
    const [isfilter, setIsFilter] = useState(false);
    const [isResetDisabled, setResetDisabled] = useState(true);
    const [filterArray, setFilterArray] = useState<string[]>([]);
    const [dropDownValue1, setDropDownValue1] = useState<any>();
    const [dropDownValue2, setDropDownValue2] = useState<any>();
    const [isdeletedisabled, setDeleteDisabled] = useState(true);
    const [messagebar2, setmessagebar2] = useState(false);
    const [isProgressLoading, setProgressLoading] = useState(false);
    const [isToast, setIsToast] = useState(false);
    const [isDeleteRole, setIsDeleteRole] = useState(false);
    const [isDeleteRoleToast, setIsDeleteRoleToast] = useState(false);
    const [createNewRole, setNewRole] = useState(false);
    const [isRefresh, setIsRefresh]: any = useState(false);
    const [exportDetails, setExportDetails]: any = useState([]);
    const [refreshToast, setRefreshToast]: any = useState(false);
    const [overLayData, setOverLayData] = useState({});
    const [handlePermission, setHandlePermission]: any = useState();
    const { permissions } = usePermissionStore();
    const [loading, setLoading] = useState(true);
    const [roleUsers, setUserRoles] = useState([])
    const [overlayName, setOverlayName] = useState('');
    const [rowID, setRowID]: any = useState(null);
    const [editRoleDetail, setEditRoleDetail] = useState(false)
    const [userRoleArray, setUserRoleArray] = useState<string[]>([])
    const [exportBtnClicked, setExportBtnClicked] = useState(false);
    const [isRoleExist, setIsRoleExist] = useState(false);
    const [roleList, setRoleList] = useState([]);
    const [tableColumnsData, setTableColumnsData] = useState([]);
    const [filterColumnsData, setFilterColumnsData] = useState([]);
    const [errorMessage, setErrorMessage] = useState<String>('')
    const [uniqueCreatedBy, setUniqueCreatedBy] = useState<string[]>([]);
    const [isCreatedBy, setCreatedBy] = useState<any[]>([]);
    const pagename = "Version";

    //save button
    const saveBtnFunc = () => {
        console.log("BUTTON CLICKED", formDataRole, '  --------   ', formDataAdmin)
        overlayName == 'edit' ? setEditRoleDetail(true) : setSaveRoleDetails(true)
        console.log('editRoleDetail --', editRoleDetail)
        setIsToast(true)
        setOverlayOpen(false)
    }
    const handleOnCLickEdit = (val: any) => {
        setOverlayName('edit');
        console.log("overlayname", overlayName)
        setOverlayOpen(true);
    }
    const menuItemsButton = (icon, text, onClick) => (
        <MenuItem onClick={onClick} icon={
            <Stack horizontal tokens={{ childrenGap: 40 }}>
                <StackItem><Text></Text></StackItem>
                <StackItem>{icon}</StackItem>
            </Stack>}>
            <Stack tokens={{ childrenGap: 30 }} horizontal>
                <StackItem><Text></Text></StackItem>
                <StackItem><Caption1> {text} </Caption1></StackItem>
                <StackItem><Stack tokens={{ childrenGap: 58 }} horizontal><StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
            </Stack>
        </MenuItem>
    )
    const ActionButton = ({ icon, text, onClick, disabled = false, tooltip }) => (
        tooltip ? (
            <Tooltip content={tooltip} relationship={"description"}>
                <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem>{icon}</StackItem>
                        <StackItem><Caption1>{text}</Caption1></StackItem>
                    </Stack>
                </Button>
            </Tooltip>
        ) : (
            <Button shape="circular" appearance="subtle" size="small" onClick={onClick} disabled={disabled}>
                <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>{icon}</StackItem>
                    <StackItem><Caption1>{text}</Caption1></StackItem>
                </Stack>
            </Button>
        )
    );  

    var overFlowComponent = {
        data:
            <>
                <Stack tokens={{ childrenGap: 10 }} horizontal>
                    <StackItem>
                        {permissions.includes("administration_Fullaccess") || permissions?.includes("here comes required permission") ? (
                            <ActionButton
                                icon={final_data ? <AddSquare20Regular {...primaryIcon} /> : <AddSquare20Regular {...secondaryIcon} />}
                                text="Create Version"
                                onClick={() => { setOverlayOpen(true); setOverlayName(''); }}
                                tooltip={undefined}
                                disabled={final_data ? false : true} />
                        ) : (
                            <ActionButton
                                icon={<AddSquare20Regular {...secondaryIcon} />}
                                text="Create Version"
                                onClick={undefined}
                                tooltip="You do not have access" />
                        )}
                    </StackItem>
                    <StackItem><Divider vertical /></StackItem>
                    <StackItem>
                        <DialogBox
                            headerButton={
                                <ActionButton
                                    icon={<Delete20Regular {...(!isdeletedisabled ? primaryIcon : secondaryIcon)} />}
                                    text="Delete"
                                    onClick={() => { }}
                                    disabled={isdeletedisabled ? true : false}
                                    tooltip={undefined} />
                            }
                            content="Kindly verify your intent to delete the version."
                            footer=
                            {
                                <>
                                    <Stack horizontal tokens={{ childrenGap: 10 }}>
                                        <StackItem>
                                            <Button shape="circular" appearance="primary" onClick={() => { setCurrentPageNo(1); }} size="small">Confirm</Button>
                                        </StackItem>
                                        <StackItem>
                                            <Button shape="circular" size="small">Cancel</Button>
                                        </StackItem>
                                    </Stack>
                                </>
                            }
                        />
                    </StackItem>
                    <StackItem> <Divider vertical /> </StackItem>
                    <StackItem>
                        <ActionButton
                            icon={<ArrowClockwise20Regular {...primaryIcon} />}
                            text="Refresh"
                            onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}
                            tooltip={undefined} />
                    </StackItem>
                    <StackItem>
                        {permissions.includes("all") || permissions?.includes("appInstallation_Fullaccess") || permissions?.includes("appInstallation_ReadandExport") ? (
                            <>
                                {/* <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_appinstallations_list.csv`}></CSVLink> */}
                                <ActionButton
                                    icon={<ArrowDownload20Regular {...primaryIcon} />}
                                    text="Export"
                                    onClick={() => { setExportBtnClicked(true); }} tooltip={undefined} />
                            </>
                        ) : (
                            <ActionButton
                                icon={<ArrowDownload20Regular {...secondaryIcon} />}
                                text="Export"
                                disabled
                                tooltip="You do not have access" onClick={undefined} />
                        )}
                    </StackItem>
                    <StackItem>
                        <ActionButton
                            icon={<Settings20Regular {...primaryIcon} />}
                            text="Manage View"
                            onClick={() => document.getElementById("manageView").click()}
                            tooltip={undefined} />
                    </StackItem>
                </Stack>
            </>
    }
    var tempTableData: any = [];
    var menuLists: any = [];
    useEffect(() => {
        console.log("second render for table data")
        // setmessagebar2(false);
        // data table values append code starts here
        console.log("final_data=", final_data);
        final_data !== undefined && final_data !== null
            ? final_data?.data?.map((val: any, i: any) => {
                console.log("inside lllllllllll")
                menuLists.push();
                // console.log("Third Render inside FinalData",userRoleArray);
                {
                    permissions.includes("all") || permissions.includes("administration_Fullaccess") ?
                        tempTableData.push({
                            checkbox: val.isAssigned ? 'hide' : 'show',
                            id: val.role,
                            role_name: {
                                label: <Button 
                                    style={buttonContent}
                                    appearance="transparent"
                                    size="small"
                                    onMouseEnter={(e) => e.currentTarget.style.textDecoration = 'underline'}
                                    onMouseLeave={(e) => e.currentTarget.style.textDecoration = 'none'}
                                    onClick={(e: any) => { handleOnCLickEdit(val) }}> {val.role} </Button>, id: `${i}`
                            },
                            createdOn: { label: <Caption1> {(val.born !== null && val.born !== " ") ? convertUTCToReadableFormat(val.born) : "-"} </Caption1> },
                            createdOn_timezoned: { label: <Caption1> {(val.born !== null && val.born !== " ") ? convertToLocalTimezone(val.born, userTimeZone) : "-"} </Caption1> },
                            modifed_on: { label: <Caption1> {(val.last !== null && val.last !== " ") ? convertUTCToReadableFormat(val.last) : "-"} </Caption1> },
                            modifed_on_timezoned: { label: <Caption1> {(val.last !== null && val.last !== " ") ? convertToLocalTimezone(val.last, userTimeZone) : "-"} </Caption1> },
                            createdBy: { label: <Caption1> {val.createdBy} </Caption1> },
                            status: { label: val.isAssigned ? <Caption1> Assigned to {val.assignedUsers.length} Users</Caption1> : <Caption1> Not Assigned </Caption1> }
                        })
                        :
                        tempTableData.push({
                            checkbox: 'hide',
                            id: val.role,
                            role_name: {
                                label:
                                    <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                                        <Button style={buttonContent} appearance="transparent" size="small"> {val.role} </Button>
                                    </Tooltip>, icon: "", id: `${i}`
                            },
                            createdOn: { label: <Caption1> {(val.born !== null && val.born !== " ") ? convertUTCToReadableFormat(val.born) : "-"} </Caption1> },
                            createdOn_timezoned: { label: <Caption1> {(val.born !== null && val.born !== " ") ? convertToLocalTimezone(val.born, userTimeZone) : "-"} </Caption1> },
                            modifed_on: { label: <Caption1> {(val.last !== null && val.last !== " ") ? convertUTCToReadableFormat(val.last) : "-"} </Caption1> },
                            modifed_on_timezoned: { label: <Caption1> {(val.last !== null && val.last !== " ") ? convertToLocalTimezone(val.last, userTimeZone) : "-"} </Caption1> },
                            createdBy: { label: <Caption1> {val.createdBy} </Caption1> },
                            status: { label: val.isAssigned ? <Caption1> Assigned to {val.assignedUsers.length} Users</Caption1> : <Caption1> Not Assigned </Caption1> }
                        })
                }
            }) : (tempTableData = []);
        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
            final_data !== undefined && final_data !== null && setLoading(false);

            if (isRefresh) {
                setIsRefresh(false);
                setRefreshToast(true);
                setTimeout(() => {
                    setRefreshToast(false);
                }, 3000);
            }
        }, 500);
    }, [final_data, permissions]);
    useEffect(() => {
        // const sections = { devices, automation, apps };
        // for (const [sectionKey, sectionArray] of Object.entries(sections)) {
        //     for (const key in formDataAdmin?.[sectionKey]) {
        //         if (Object.hasOwnProperty.call(formDataAdmin?.[sectionKey], key)) {
        //             sectionArray.push(formDataAdmin?.[sectionKey][key]);
        //         }
        //     }
        // }

        setOverLayData({
            headerTitle: <> {overlayName == 'edit' ? <Title3>Edit Version</Title3> : <Title3>Create Version</Title3>}</>,
            size: "large",
            isTabs: true,
            tabItems: {
                Introduction:
                    <>
                        <Stack tokens={{ childrenGap: 15 }}>
                            <InfoBar title={" These are the basic details  associated with this Roles. You can retain them or modify them to suit your specific use case."} />
                            <StackItem> <Body1Strong> Name </Body1Strong> </StackItem>
                            <Input size="small" />
                            <StackItem> <Body1Strong> Operating System </Body1Strong> </StackItem>
                            <DropdownComponent />
                            <StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
                            <Textarea />
                        </Stack>
                    </>,
                Version:
                    <>
                        <Stack tokens={{ childrenGap: 15 }}>
                            <StackItem>Version Number</StackItem>
                            <Input size="small" />
                            <StackItem>Version update file download URL</StackItem>
                            <Input size="small" />
                        </Stack>
                    </>,
                "Review Data":
                    <Stack>
                        <Stack tokens={{ childrenGap: 15 }}>
                            <InfoBar title={" These are the basic details  associated with this Roles. You can retain them or modify them to suit your specific use case."} />
                            <StackItem> <Body1Strong> Name </Body1Strong> </StackItem>
                            <Input size="small" />
                            <StackItem> <Body1Strong> Operating System </Body1Strong> </StackItem>
                            <DropdownComponent />
                            <StackItem> <Body1Strong> What is the benefit? </Body1Strong> </StackItem>
                            <Textarea />
                            <StackItem><Body1Strong>Version Number<Body1Strong /></Body1Strong></StackItem>
                            <Input size="small" />
                            <StackItem><Body1Strong>Version update file download URL<Body1Strong /></Body1Strong></StackItem>
                            <Input size="small" />
                        </Stack>
                    </Stack>
            }
        })


        // console.log("jsnschema", jsonSchemaPermisssion)
    }, [formDataRole, formDataAdmin, overlayName]);
    useEffect(() => {
        if (saveBtnClicked) {
            setOverlayOpen(false);
            // handleBothSetMessage();
        }
    }, [saveBtnClicked]);

    return (
        <>
            <FullScreen handle={handle} className="fullScreenBackgroundColor">
                <StackItem grow shrink>
                    <Stack tokens={{ childrenGap: 10 }} horizontal>
                        <StackItem grow shrink>
                            <Stack horizontalAlign="start">
                                <StackItem grow shrink> <Breadcrumbs pageName="Administration" subPageName="" subPageLink="#" /> </StackItem>
                            </Stack>
                        </StackItem>
                        <StackItem grow shrink>
                            <Stack horizontalAlign="end">
                                <StackItem grow shrink>
                                    <FullScreenButton handle={handle} />
                                </StackItem>
                            </Stack>
                        </StackItem>
                    </Stack>
                </StackItem>
                <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
                    <StackItem>
                        {/* pages code starts here */}
                        <FluentProvider theme={dashboardTheme}>
                            <Stack>
                                <Stack tokens={{ childrenGap: 25 }} horizontal>
                                    <StackItem> <Text /> </StackItem>
                                    <StackItem>
                                        <Title3> Administration | Roles </Title3>
                                    </StackItem>
                                </Stack>

                                <Stack tokens={{ childrenGap: 20 }}><StackItem><Text /></StackItem><StackItem><Text /></StackItem></Stack>

                                <Stack horizontal>
                                    {/* SPACING BETWEEN INLINE AND PAGE */}
                                    <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={AdministrationPages(`Version${" "}Update`)} />
                                    <StackItem>
                                        <StackItem> <Text /> </StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}><StackItem><Text /></StackItem><StackItem><Text /></StackItem></Stack>
                                        <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
                                            <StackItem>
                                                <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                                                <Divider />
                                            </StackItem>
                                            <StackItem>
                                                <StackItem>
                                                    <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                                                    <StackItem><Text></Text></StackItem>
                                                    <StackItem>
                                                        <SearchBar setCurrentPageNo={setCurrentPageNo} columnSearch={"Role"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                                        </StackItem>
                                                        {/* <StackItem>
                                                        <MenuDropdown open={filterMenuOpen} btn=
                                                            {
                                                                <MenuButton shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                        {loading?<Filter20Filled {...secondaryIcon} />:<Filter20Filled {...primaryIcon} />}
                                                                        <Body1> Filter </Body1>
                                                                    </Stack>
                                                                </MenuButton>
                                                            } itemVal={
                                                                <>
                                                                    <Body1Strong> Add a Filter </Body1Strong>
                                                                    <Divider />
                                                                    <MenuList>
                                                                        <Stack tokens={{ childrenGap: 5 }}>
                                                                            <StackItem> <Text /> </StackItem>
                                                                            <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                                                            <DropdownComponent optionData={filterColumnsData} setDropDownValue={(newValue) => { setDropDownValue1(newValue); setDropDownValue2(''); }} dropDownvalue={dropDownValue1} />
                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <StackItem> <Caption1> Value </Caption1> </StackItem>
                                                                            {(dropDownValue1 === 'Created On' || dropDownValue1 === 'Modified On') && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? ( <span style={{ color: 'red' }}>This column is already filtered</span> ) :  (<DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />))}
                                                                            {(dropDownValue1 === "Role Name" ||  dropDownValue1 === "Status") && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? ( <span style={{ color: 'red' }}>This column is already filtered</span> ) : (<Input size="small"   onChange={inputChange} name="filter" value={dropDownValue2}/>))}
                                                                            {dropDownValue1 === "Created By" && (filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`)) ? ( <span style={{ color: 'red' }}>This column is already filtered</span> ) : (<DropdownComponent optionData={isCreatedBy} setDropDownValue={setDropDownValue2} dropDownvalue={dropDownValue2}/>))}

                                                                            <StackItem> <Divider /> </StackItem>
                                                                            <Stack tokens={{ childrenGap: 10 }} horizontal>
                                                                                <StackItem>
                                                                                    <Button shape="circular"
                                                                                        appearance="primary"
                                                                                        onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                                                                        disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))}
                                                                                    >  <Caption1> Apply </Caption1> </Button>
                                                                                </StackItem>

                                                                                <StackItem>
                                                                                    <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                                                                        <Caption1> Cancel </Caption1>
                                                                                    </Button>
                                                                                </StackItem>
                                                                            </Stack>
                                                                        </Stack>
                                                                    </MenuList>
                                                                </>
                                                            }
                                                        />
                                                    </StackItem> */}
                                                        {/* <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2('');setDropDownValue1(''); setResetDisabled(true); setLoading(true); }}>
                                                        <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                <StackItem> <FilterDismiss20Filled /> </StackItem>
                                                                <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                                            </Stack>
                                                        </Button>
                                                    </StackItem> */}

                                                        {/* <StackItem>
                                                        {filterArray.length > 0 && filterArray.map((item, index) => (
                                                            <Button shape="circular" size="small" shape="circular">
                                                                <Stack tokens={{ childrenGap: 5 }} horizontal>
                                                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                                                    <StackItem>
                                                                        <Stack tokens={{ childrenGap: 1 }}>
                                                                            <StackItem><Text></Text></StackItem>
                                                                            <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                                                        </Stack>
                                                                    </StackItem>
                                                                </Stack>
                                                            </Button>
                                                        ))}
                                                    </StackItem>                                                   */}
                                                    </Stack>
                                                </StackItem>
                                                {/* <InfoBar showSpaces={true} title={"Creating roles involves defining sets of permissions and access levels that determine what actions users with the assigned role can perform. Role creation options include None (no access), Read (view only), Read and Export (view and export), and Full Access (view, export, and perform Create, Read, Edit, and Delete operations), ensuring appropriate access control based on user responsibilities."} /> */}
                                                {(tableData.length > 0 && !loading) && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                                                    <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                                                    <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>
                                                </Stack>}
                                            </StackItem>
                                            <Admin_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} rowID={rowID} setRowID={setRowID} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} formDataRole={formDataRole} setFormDataRole={setFormDataRole} formDataAdmin={formDataAdmin} setFormDataAdmin={setFormDataAdmin} saveRoleDetails={saveRoleDetails}
                                                setDeleteDisabled={setDeleteDisabled} setSaveRoleDetails={setSaveRoleDetails} isFilter={isfilter}
                                                dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} editRoleDetail={editRoleDetail} setEditRoleDetail={setEditRoleDetail} isDeleteRole={isDeleteRole} setIsDeleteRole={setIsDeleteRole}
                                                setExportDetails={setExportDetails}
                                                setIsRefresh={setIsRefresh} setIsToast={setIsToast} isRefresh={isRefresh} setRefreshToast={setRefreshToast}
                                                setIsDeleteRoleToast={setIsDeleteRoleToast} isDeleteRoleToast={isDeleteRoleToast} setNewRole={setNewRole} createNewRole={createNewRole} setHandlePermission={setHandlePermission} handlePermission={handlePermission} setUserRoles={setUserRoles} roleUsers={roleUsers}
                                                exportBtnClicked={exportBtnClicked}
                                                setExportBtnClicked={setExportBtnClicked}
                                                setIsRoleExist={setIsRoleExist}
                                                setLoading={setLoading}
                                                setUserRoleArray={setUserRoleArray}
                                            />

                                            {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} setOverlayOpen={setOverlayOpen} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                                        </Stack>
                                    </StackItem>
                                </Stack>
                                <OverLay formRef={formRef} overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} isNavBtn={true} saveBtnFunc={saveBtnFunc} pagename={pagename} />
                            </Stack>
                        </FluentProvider>
                    </StackItem>
                    <StackItem><Text /></StackItem>
                </Stack>
            </FullScreen>
        </>
    )
}
